import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Get saved language from localStorage or fallback to 'en'
const savedLang = localStorage.getItem('language') || 'en';

i18n
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    lng: savedLang,
    resources: {
      en: {
        translations: require('./en/en.json'),
      },
      pr: {
        translations: require('./pr/pr.json'),
      },
    },
    ns: ['translations'],
    defaultNS: 'translations',
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

i18n.languages = ['en', 'pr'];

export default i18n;
